import React from 'react';
import PropTypes from 'prop-types';
import LoginForm from './Form';

const Component = ({ Styled, ...rest }) => {
  return (
    <Styled.LoginParentWrapper>
      <Styled.LeftWrapper>
        <div className="login-right-wrap">
          <LoginForm {...rest} Styled={Styled} />
        </div>
      </Styled.LeftWrapper>
      <Styled.RightWrapper />
    </Styled.LoginParentWrapper>
  );
};

export default Component;
Component.defaultProps = { hasRegistration: true };
Component.propTypes = {
  Styled: PropTypes.object.isRequired
};
